# Set up for a website (Low code)

## Create a Site Chat account
Your first step is to set up a [Site Chat account](https://www.site-chat.com/console), unless you already have one. Skip to creating a property unless you want to create a separate account for this website and/or app. For example, you might want to create another account if this website and/or app belong(s) to a separate business.


## Directly add a Site Chat bot to your site
1. Sign in to your [Site Chat account](https://www.site-chat.com/console).
2. In the left sidebar, click **Create a Bot** or an created bot.  Configure the bot if needed.  Any changes will be saved automatically and most of changes will take effect immediately.  *You can always come back and change the bot configuration later.*
3. Turn on the **Live Mode**.
4. Click the **Get code** button next to the Bot ID.  You will see a code block pop up.

   ![intergration_note](/assets/documentation/intergration/intergration_note.png)
5. On the screen, you’ll see the code snippet for adding a Site Chat bot to your site.  Just paste the `<script>` bolck immediately before the `</body>` on each page of your website.

```javascript
<html>
<head> 
</head>
<body>  
    <!-- Site Chat Script and Tag -->
    <script data-bot-id="C-your-bot-id" id="site-chat-script" 
        src="https://www.site-chat.com/lib/site-chat.js" type="module">
    </script>
</body>
</html>
```

### Next steps
After setting up your Site Chat bot, it's highly recommended to simulate user behavior and use Customer Insight Analytics tools for guidance in enhancing your bot. Regularly visit your [Site Chat console](https://www.site-chat.com/console) to monitor user interactions and observe how their appreciation for your bot evolves over time.